import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from '@/hooks/use-session';
import { paths } from '@/lib/paths';

/**
 * Garde de sécurité (Middleware) côté client.
 * Elle bloque l'accès aux routes enfants si l'utilisateur n'a pas d'accès actif.
 */
export function ProtectedRoute() {
    const { hasAccess } = useSession();

    // 1. Si l'accès n'est pas encore actif (non payé ou session expirée),
    // on redirige le visiteur vers la page de connexion ou d'accueil.
    if (!hasAccess) {
        return <Navigate to={paths.login} replace />;
    }

    // 2. Si l'accès est validé, on affiche le composant enfant demandé
    // grâce au composant <Outlet /> de React Router.
    return <Outlet />;
}
